// extracted by mini-css-extract-plugin
export default {"container":"style_container__TdRiL","imageBox":"style_imageBox__Q73Bp"};